export default __webpack_public_path__ + "KaTeX_Main-Italic.44a32ae60521190623e30c98de29ef17.ttf";